import React from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const PURPOSE_OPTIONS = [
  "color_scheme",
  "inspiration",
  "texture_detail",
  "font_reference",
  "other",
];

const ReferenceImageUploader = ({
  images = [],
  onUpload,
  onRemove,
  onPurposeChange,
  fileInputRef,
}) => {
  const handleCustomLabelChange = (index, value) => {
    const image = images[index];
    onPurposeChange(index, image.purpose, value);
  };

  return (
    <Box sx={{ width: "100%", p: 2 }}>
      <Typography variant="body2" fontWeight="bold" gutterBottom>
        Reference Images (Secondary Only)
      </Typography>

      <Box display="flex" flexWrap="wrap" gap={2} mb={2}>
        {images.map((img, index) => (
          <Box
            key={img.url || index}
            position="relative"
            display="flex"
            flexDirection="column"
            alignItems="center">
            <img
              src={img.url}
              alt={img.customPurpose || img.purpose || "Reference"}
              style={{
                width: 80,
                height: 80,
                borderRadius: 4,
                objectFit: "cover",
              }}
            />
            <IconButton
              size="small"
              onClick={() => onRemove(index)}
              sx={{ position: "absolute", top: -8, right: -8 }}>
              <DeleteIcon fontSize="small" />
            </IconButton>

            <FormControl fullWidth size="small" sx={{ mt: 1 }}>
              <InputLabel>Purpose</InputLabel>
              <Select
                value={img.purpose || ""}
                onChange={(e) =>
                  onPurposeChange(index, e.target.value, img.customPurpose)
                }
                label="Purpose">
                {PURPOSE_OPTIONS.map((opt) => (
                  <MenuItem key={opt} value={opt}>
                    {opt
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (c) => c.toUpperCase())}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {img.purpose === "other" && (
              <TextField
                label="Custom Purpose"
                value={img.customPurpose || ""}
                onChange={(e) => handleCustomLabelChange(index, e.target.value)}
                size="small"
                fullWidth
                sx={{ mt: 1 }}
              />
            )}
          </Box>
        ))}
      </Box>

      <Button
        startIcon={<UploadFileIcon />}
        onClick={() => fileInputRef.current?.click()}>
        Upload Images
      </Button>

      <input
        type="file"
        multiple
        accept="image/*"
        ref={fileInputRef}
        onChange={onUpload}
        style={{ display: "none" }}
      />
    </Box>
  );
};

export default ReferenceImageUploader;
